// "Facebook ad account card" panel on My Invoices, opened from the request
// email / payment-issue email (?fb-card=<slug>), the banner, or the header
// button. Deliberately separate from the Billing drawer: the cards there are
// the ones WE charge for invoices (Stripe); this one goes on the client's
// Facebook ad account, so Facebook needs the full number.
import React from 'react';

import { Alert, Box, Divider, Drawer, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import AdAccountCardForm from '@src/components/cardVault/AdAccountCardForm';

export default function FacebookCardDrawer({ open, onClose, clients, focusSlug }) {
  // A parent login can see many brands; when the link names one, show only it.
  const focused = clients.filter((c) => c.client_slug === focusSlug);
  const shown = focused.length ? focused : clients;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: '100%', sm: 560 } } }}
    >
      <Box sx={{ p: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 2 }}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Facebook ad account card
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              The card Facebook charges for your ad spend.
            </Typography>
          </Box>
          <IconButton onClick={onClose} aria-label="Close Facebook card">
            <CloseIcon />
          </IconButton>
        </Stack>

        <Alert severity="info" variant="outlined" sx={{ mb: 3 }}>
          Facebook bills your ad account directly for ad spend. We need the full card details to add it
          there for you, so you never have to log in to Facebook. This is separate from the card we charge
          for our invoices under Billing.
        </Alert>

        <Stack spacing={3} divider={<Divider flexItem />}>
          {shown.map((c) => (
            <Box key={c.client_slug}>
              {shown.length > 1 && (
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                  {c.client_name}
                </Typography>
              )}
              <AdAccountCardForm clientSlug={c.client_slug} embedded />
            </Box>
          ))}
        </Stack>
      </Box>
    </Drawer>
  );
}
